/* eslint-disable no-bitwise */
/* eslint-disable no-unused-vars */

const selectedlink = () => {
  const selected = document.querySelector('.js-select-links select');
  if (selected) {
    selected.addEventListener('change', e => {
      if (e.target.value !== 0) {
        window.location = e.target.value;
      }
    });
  }
};

export default selectedlink;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/vistula-chisel/src/scripts/modules/selectedlink.js